import { useEffect } from 'react'
import { deviceTimezone } from '@/shared/lib'
import { useReportTimezone } from '../api/mutations'
import { useSession } from './use-session'

// Зона в хабе — последняя увиденная зона устройства сотрудника, и переставляет
// её SPA: спрашивать человека значит хранить настройку, а она протухает молча —
// люди летают. Сверка молчаливая, без диалогов и подтверждений: на экране зона
// всегда берётся у устройства напрямую, а хабу зона нужна только для тех мест,
// где экрана нет, — текста письма и алерта бота в продуктах.
//
// Ошибка записи не эскалируется: следующая загрузка сессии догонит. Цена —
// текст алерта узнаёт о перелёте не мгновенно, а к ближайшему открытию хаба.
export function useDeviceTimezoneSync(): void {
  const { session } = useSession()
  const { mutate } = useReportTimezone()
  const saved = session?.timezone

  useEffect(() => {
    if (saved === undefined) return
    const device = deviceTimezone()
    if (!device || device === saved) return
    mutate(device)
  }, [saved, mutate])
}
